import {createRouter, createWebHistory, RouterView} from 'vue-router'
import homeRoutes from "@/router/homeRoutes";
import {IBreadcrumbMeta} from "cdp-fe-commons-layout";
import {useUserStore} from "@/stores/user";

declare module 'vue-router' {
  interface RouteMeta {
    breadcrumb: IBreadcrumbMeta
  }
}

const routes = [
  {
    path: '/',
    name: 'Root',
    component: RouterView,
    meta: {
      title: 'Sportello online',
      breadcrumb: {
        icon: 'it-pa',
        customName: 'Home'
      } as IBreadcrumbMeta
    },
    children: homeRoutes
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

router.beforeEach(async (to, from, next) => {
  const userStore = useUserStore();
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (await userStore.isAuthenticated()) {
      next();
      return;
    }
    next("/servizi");
  } else {
    next();
  }
});
export default router
